import React from 'react'

function Standardy() {
  return (
    <div>Standardy</div>
  )
}

export default Standardy